<div class="container-fluid px-2 mt-3">
  <div class="row">
    <div class="col-12">
      <form class="row g-3">
        <!-- Bank Account Number -->
        <div class="col-12 col-md-5">
          <app-input 
            onlyNumbers
            [onlyNumbers]="true"
            [inputName]="'bankAccountNumber'" 
            [inputType]="'text'"
            [inputId]="'bankAccountNumber'" 
            [inputValue]="bankDetails.bankAccountNumber"
            [inputLabel]="'Bank Account No.'"
            [inputPlaceholder]="''"
            (inputValueEmit)="bankDetails.bankAccountNumber=$event"
            [isRequired]="false">
          </app-input>
        </div>

        <!-- Branch Name -->
        <div class="col-12 col-md-5">
          <app-input 
            [inputName]="'branchName'" 
            [inputType]="'text'"
            [inputId]="'branchName'" 
            [inputValue]="bankDetails.branchName"
            [inputLabel]="'Branch Name'"
            [inputPlaceholder]="''"
            (inputValueEmit)="bankDetails.branchName=$event"
            [isRequired]="false">
          </app-input>
        </div>

        <!-- Bank Name -->
        <div class="col-12 col-md-5">
          <app-input 
            [inputName]="'bankName'" 
            [inputType]="'text'"
            [inputId]="'bankName'" 
            [inputValue]="bankDetails.bankName"
            [inputLabel]="'Bank Name'"
            [inputPlaceholder]="''"
            (inputValueEmit)="bankDetails.bankName=$event"
            [isRequired]="false">
          </app-input>
        </div>

        <!-- Account Holder Name -->
        <div class="col-12 col-md-5">
          <app-input 
            [inputName]="'accountHolderName'" 
            [inputType]="'text'"
            [inputId]="'accountHolderName'" 
            [inputValue]="bankDetails.accountHolderName"
            [inputLabel]="'Account Holder Name'"
            [inputPlaceholder]="''"
            (inputValueEmit)="bankDetails.accountHolderName=$event"
            [isRequired]="false">
          </app-input>
        </div>

        <!-- IFSC Code -->
        <div class="col-12 col-md-5">
          <app-input 
            [inputName]="'ifscCode'" 
            [inputType]="'text'"
            [inputId]="'ifscCode'" 
            [inputValue]="bankDetails.ifscCode"
            [inputLabel]="'IFSC Code'"
            [inputPlaceholder]="''"
            (inputValueEmit)="bankDetails.ifscCode=$event"
            [isRequired]="false">
          </app-input>
        </div>

        <!-- Referred By -->
        <div class="col-12 col-md-5">
          <app-input 
            [inputName]="'referBy'" 
            [inputType]="'text'"
            [inputId]="'referBy'" 
            [inputValue]="bankDetails.referBy"
            [inputLabel]="'Referred by'"
            [inputPlaceholder]="''"
            (inputValueEmit)="bankDetails.referBy=$event"
            [isRequired]="false">
          </app-input>
        </div>
      </form>
    </div>
  </div>
</div>
